import axios from 'axios'

export function getAllDict() {
  return axios({
    url: '/sys/dict/item/getDictByType',
    method: 'post',
    data: {}
  })
}

export function getDictList(params) {
  return axios({
    url: '/sys/dict/page',
    method: 'post',
    data: params
  })
}

export function delDict(id) {
  return axios({
    url: '/sys/dict/removeById',
    method: 'post',
    data: {id}
  })
}

export function addDict(obj) {
  return axios({
    url: '/sys/dict/save',
    method: 'post',
    data: obj
  })
}

export function updateDict(obj) {
  return axios({
    url: '/sys/dict/update',
    method: 'post',
    data: obj
  })
}

export function getDictItemList(params) {
  return axios({
    url: '/sys/dict/item/page',
    method: 'post',
    data: params
  })
}

export function addDictItem(obj){
  return axios({
    url: '/sys/dict/item/save',
    method: 'post',
    data: obj
  })
}

export function updateDictItem(obj){
  return axios({
    url: '/sys/dict/item/update',
    method: 'post',
    data: obj
  })
}

export function delDictItem(id){
  return axios({
    url: '/sys/dict/item/removeById',
    method: 'post',
    data: {id}
  })
}

export function getDictItemDetail(id) {
  return axios({
    url: '/sys/dict/item/getById',
    method: 'post',
    data: {id}
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/dict.js